import React from 'react';
import API from '../../configAPI';

class Carousel extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            slides : []
        }
    }
    componentDidMount(){
        API.PRODUCTS('slides')
        .then(resp =>{
            this.setState({
                slides : resp.data
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    render(){
        return(
            <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    {this.state.slides.map((slide,index) => (
                        <div className={`carousel-item ${index === 0 ? 'active': ''}`} key={index}>
                            <div className="d-flex align-items-start justify-content-center">
                                <img src={slide.url_image} className="size-img-slide" alt={slide.title}/>
                                <div className="carousel-caption d-none d-md-block carousel-text">
                                <h3 className={`slide-title ${slide.theme_color === 1 ? 'white': 'black'}`}>{slide.title}</h3>
                                <a href={slide.action_link} target="_blank" rel="noopener noreferrer" className="btn btn-dark btn-sm" >{slide.action_name}</a>
                                </div>
                            </div>
                        </div>
                    ))}
                    <a className="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        )
    }
}

export default Carousel;